import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { useState, useRef, useEffect } from "react"
import { SiteVideoMedia } from "../../../../siteWidgets/siteMedia";
import { getFrontImageUrl } from "../../../../../front/staticServerRendering/frontImage";
import { ImageSize } from "../../../../../constants/imageSizes";
import { ArticleExtraData } from "../../../../../articlePage/stateInterfaces";
import { MediaContentTypes } from "../../../../../constants/contentTypes";
import { SiteVideoData } from "../../../../interfaces";
import { openFacebookShare, openWhatsAppShare, openTwitterShare } from "../../../../widgetsUtils";
import { SimpleAudioPlayer } from "../../simpleAudioPlayer/simpleAudioPlayer";
import { VideoSettingsData } from "commonDataObjects/interfaces"


interface RadionasFlashItemProps {
    article: ArticleExtraData
    audioDomain: string
    isMobileWeb: boolean
    authorCaptionColor: string
    dateCaptionColor: string
    newsflashCaptionColor: string
    componentBackgroundColor: string
    videoSettings?: VideoSettingsData
    domain:string
}


export const RadionasFlashItem = (props: RadionasFlashItemProps) =>  {
    const { article, isMobileWeb, authorCaptionColor, dateCaptionColor,  componentBackgroundColor,  audioDomain, videoSettings, domain } = props
    const [isShareMenuOpen, setIsShareMenuOpen] = useState<boolean>(false)
    const itemRef = useRef<HTMLDivElement>()
   const flashItemStyles = isMobileWeb ? { backgroundColor: componentBackgroundColor } : {  backgroundColor: componentBackgroundColor }
 


    const getArticleMedia = () => {
        switch (article.specialData.mediaLinkType!==undefined  && article.specialData.mediaLinkType) {
            case "image":
                return <img src={getFrontImageUrl({ publishedLink: article.promotionImageDetails.publishedLink }, { imageSize: ImageSize.large })} />

            case "video":
                const videoData: SiteVideoData = {
                    mediaType: MediaContentTypes.MEDIA_VIDEO,
                    url: article.video[0].main_link,
                    downGradeUrl: article.video[0].low_res_link,
                    poster: article.video[0].posterSrc,
                    isPlayerBarVisible: article.specialData.videoBehaivior.isPlayerBarVisible,
                    isAutoPlaying: false,
                    isLoopPlaying: article.specialData.videoBehaivior.isLoopPlaying,
                    isMuteAvailable: article.specialData.videoBehaivior.isMuteAvailable,
                    isSoundButtonVisible: article.specialData.videoBehaivior.isSoundButtonVisible,
                    isBigVideo: true,
                    youtube_id: article.video[0].youtube_id,
                    mediaId: article.video[0].mediaVideoId,
                    blockAbroadViews: article.video[0].blockAbroadViews,
                    credit: article.video[0].credit,
                }

                return <SiteVideoMedia data={videoData} videoSettings={videoSettings} />

            case "audio":
                return <SimpleAudioPlayer src={`${audioDomain}${article.specialData.audioNewsflashData.filePath}`} duration={article.specialData.audioNewsflashData.durationSeconds} />

            default:
                break;
        }
    }

    const handleShareBtnClick = () => {
        if (isMobileWeb) {
            openMobileShare()
        } else {
            setIsShareMenuOpen(!isShareMenuOpen)
        }
    }
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (itemRef.current && !itemRef.current.contains(event.target as Node)) {
                setIsShareMenuOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        document.addEventListener('mouseout', handleClickOutside)
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside)
            document.addEventListener('mouseout', handleClickOutside)
        }
    }, [itemRef])
    const openMobileShare = async () => {
        const shareData = { url: article.publishedLink, title: article.title }
        try {
            // @ts-ignore 
            await navigator.share(shareData)
        } catch (err) {
            console.log("error with sharing function", err);
        }
    }
   
    return (
        <div className="radionas-flash-item" style={flashItemStyles} ref={itemRef as any}>
            <div className="radionas-flash-item-inner">
                <div className={`flash-item-expandable-container`} >
                      <div className="author-details">
                            {article.firstAuthorImage ?
                                <img className="author-image" src={domain+article.firstAuthorImage} />
                                :
                                <div className="author-image default-author-image"></div>
                            }
                            <div className="author-name" style={{ color: authorCaptionColor }}>{article.author}</div>
                        </div>

    
                   

                    <div className="flash-item-body">
                        {getArticleMedia()}
                        <div className="article-title">{article.title}</div>
                    </div>

                    <div className="flash-item-footer">
                       <DateDisplay date={article.dateUpdatedOnSite} hiddenYesterday  />  
                        <div className="share-btn icon" onClick={handleShareBtnClick}> </div>
                            {isShareMenuOpen && !isMobileWeb &&
                                <div className="share-menu">
                                    <div className="twitter icon" onClick={() => openTwitterShare(article.publishedLink)}></div>
                                    <div className="whatsapp icon" onClick={() => openWhatsAppShare(article.publishedLink)}></div>
                                    <div className="facebook icon" onClick={() => openFacebookShare(article.publishedLink, article.title)}></div>
                                </div>}             
                    </div>
                </div>
            </div>
        </div>
    )

}
